<div
  class="other-insurer-card"
  [ngClass]="selected ? 'highlight' : ''"
  (click)="toggleSelection()"
>
  <img [src]="insurer?.image" alt="" style="max-width: 100px; width: 100%" />
  <div class="other-insurer-card__title">{{ insurer?.name }}</div>
</div>
